
(function() {
  var result = { translations: { "no-no": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albansk", "sq-al": "Albansk \u2013 Albania", "ar": "Arabisk", "ar-dz": "Arabisk \u2013 Algerie", "ar-bh": "Arabisk \u2013 Bahrain", "ar-eg": "Arabisk \u2013 Egypt", "ar-iq": "Arabisk \u2013 Irak", "ar-jo": "Arabisk \u2013 Jordan", "ar-kw": "Arabisk \u2013 Kuwait", "ar-lb": "Arabisk \u2013 Libanon", "ar-ly": "Arabisk \u2013 Libya", "ar-ma": "Arabisk \u2013 Marokko", "ar-om": "Arabisk \u2013 Oman", "ar-qa": "Arabisk \u2013 Qatar", "ar-sa": "Arabisk \u2013 Saudi-Arabia", "ar-sd": "Arabisk \u2013 Sudan", "ar-sy": "Arabisk \u2013 Syria", "ar-tn": "Arabisk \u2013 Tunisia", "ar-ae": "Arabisk \u2013 De forente arabiske emirater", "ar-ye": "Arabisk \u2013 Jemen", "as": "Assamesisk", "az": "Aserbajdsjansk", "hy": "Armensk", "eu": "Baskisk", "be": "Hviterussisk", "be-by": "Hviterussisk \u2013 Hviterussland", "bn": "Bengali", "bg": "Bulgarsk", "bg-bg": "Bulgarsk \u2013 Bulgaria", "bs": "Bosnisk", "ca": "Katalansk", "ca-es": "Katalansk \u2013 Catalonia", "zh": "Kinesisk", "zh-cn": "Kinesisk \u2013 forenklet", "zh-hk": "Kinesisk \u2013 Hong Kong", "zh-mo": "Kinesisk \u2013 Macau", "zh-sg": "Kinesisk \u2013 Singapore", "zh-tw": "Kinesisk \u2013 tradisjonell", "zh-chs": "Kinesisk (forenklet)", "zh-cht": "Kinesisk (tradisjonell)", "zh-hans": "Kinesisk (Forenklet Han)", "zh-hant": "Kinesisk (Tradisjonell Han)", "hr": "Kroatisk", "hr-hr": "Kroatisk \u2013 Kroatia", "cs": "Tsjekkisk", "cs-cz": "Tsjekkisk \u2013 Tsjekkia", "da": "Dansk", "da-dk": "Dansk \u2013 Danmark", "nl": "Nederlandsk", "nl-be": "Nederlandsk \u2013 Belgia", "nl-ch": "Nederlandsk - Sveits", "nl-lu": "Nederlandsk \u2013 Luxembourg", "nl-nl": "Nederlandsk \u2013 Nederland", "en": "Engelsk", "en-ae": "Engelsk \u2013 De forente arabiske emirater", "en-au": "Engelsk \u2013 Australia", "en-be": "Engelsk \u2013 Belgia", "en-ca": "Engelsk \u2013 Canada", "en-ch": "Engelsk - Sveits", "en-cn": "Engelsk \u2013 Kina", "en-de": "Engelsk - Tyskland", "en-ee": "Engelsk - Estland", "en-es": "Engelsk - Spania", "en-fr": "Engelsk - Frankrike", "en-hk": "Engelsk \u2013 Hong Kong", "en-in": "Engelsk \u2013 India", "en-ie": "Engelsk \u2013 Irland", "en-ke": "Engelsk \u2013 Kenya", "en-lu": "Engelsk \u2013 Luxembourg", "en-my": "Engelsk \u2013 Malaysia", "en-mt": "Engelsk \u2013 Malta", "en-mx": "Engelsk - Mexico", "en-nl": "Engelsk \u2013 Nederland", "en-nz": "Engelsk \u2013 New Zealand", "en-ph": "Engelsk \u2013 Filippinene", "en-pk": "Engelsk \u2013 Pakistan", "en-se": "Engelsk - Sverige", "en-sg": "Engelsk \u2013 Singapore", "en-tn": "Engelsk - Tunisia", "en-za": "Engelsk \u2013 S\xF8r-Afrika", "en-gb": "Engelsk \u2013 Storbritannia", "en-us": "Engelsk \u2013 USA", "en-zw": "Engelsk \u2013 Zimbabwe", "et": "Estisk", "et-ee": "Estisk \u2013 Estland", "fo": "F\xE6r\xF8ysk", "fa": "Farsi", "fi": "Finsk", "fi-fi": "Finsk \u2013 Finland", "fil": "Filippinsk", "fr": "Fransk", "fr-be": "Fransk \u2013 Belgia", "fr-ca": "Fransk \u2013 Canada", "fr-fr": "Fransk \u2013 Frankrike", "fr-lu": "Fransk \u2013 Luxembourg", "fr-mc": "Fransk \u2013 Monaco", "fr-ch": "Fransk \u2013 Sveits", "fr-tn": "Fransk \u2013 Tunisia", "gl": "Galisisk", "ka": "Georgisk", "de": "Tysk", "de-at": "Tysk \u2013 \xD8sterrike", "de-de": "Tysk \u2013 Tyskland", "de-gr": "Tysk \u2013 Hellas", "de-li": "Tysk \u2013 Liechtenstein", "de-lu": "Tysk \u2013 Luxembourg", "de-ch": "Tysk \u2013 Sveits", "el": "Gresk", "el-cy": "Gresk \u2013 Kypros", "el-gr": "Gresk \u2013 Hellas", "gu": "Gujarati", "haw": "Hawaiisk", "ha": "Hausa", "he": "Hebraisk", "he-il": "Hebraisk \u2013 Israel", "iw-il": "Hebraisk \u2013 Israel", "hi": "Hindi", "hi-in": "Hindi \u2013 India", "hu": "Ungarsk", "hu-hu": "Ungarsk \u2013 Ungarn", "is": "Islandsk", "is-is": "Islandsk \u2013 Island", "id": "Indonesisk", "in-id": "Indonesisk \u2013 Indonesia", "ga": "Irsk", "ga-ie": "Irsk \u2013 Irland", "it": "Italiensk", "it-it": "Italiensk \u2013 Italia", "it-ch": "Italiensk \u2013 Sveits", "ja": "Japansk", "ja-jp": "Japansk \u2013 Japan", "kn": "Kannada", "kk": "Kasakhisk", "kok": "Konkani", "ko": "Koreansk", "ko-kr": "Koreansk \u2013 S\xF8r-Korea", "ku": "Kurdisk", "ky": "Kirgisisk", "ky-kg": "Kirgisisk", "lo": "Lao", "lv": "Latvisk", "lv-lv": "Latvisk \u2013 Latvia", "lt": "Litauisk", "lt-lt": "Litauisk \u2013 Litauen", "mk": "Makedonsk", "mk-mk": "Makedonsk \u2013 Makedonia", "ml": "Malayalam", "ms": "Malay", "ms-bn": "Malay \u2013 Brunei", "ms-my": "Malay \u2013 Malaysia", "mt": "Maltesisk", "mt-mt": "Maltesisk \u2013 Malta", "mr": "Marathi", "mn": "Mongolsk", "my": "Burmesisk", "my-mm": "Burmesisk - Myanmar (Burma)", "ne": "Nepali", "no": "Norsk", "nb": "Norsk bokm\xE5l", "nb-no": "Norsk Bokmal - Norge", "no-no": "Norsk \u2013 Norge", "pl": "Polsk", "pl-pl": "Polsk \u2013 Polen", "pt": "Portugisisk", "pt-br": "Portugisisk \u2013 Brasil", "pt-pt": "Portugisisk \u2013 Portugal", "pa": "Punjabi", "pa-in": "Punjabi - India", "pa-pk": "Punjabi \u2013 Pakistan", "ro": "Rumensk", "ro-ro": "Rumensk \u2013 Romania", "ru": "Russisk", "ru-ru": "Russisk \u2013 Rusland", "rw-rw": "Kinyarwanda", "sa": "Sanskrit", "si": "Sinhala", "sr": "Serbisk", "sr-ba": "Serbisk \u2013 Bosnia-Hercegovina", "sr-me": "Serbisk \u2013 Montenegro", "sr-rs": "Serbisk \u2013 Serbia", "sr-cs": "Serbisk \u2013 Serbia og Montenegro (tidligere)", "sk": "Slovakisk", "sk-sk": "Slovakisk \u2013 Slovakia", "sl": "Slovensk", "sl-si": "Slovensk \u2013 Slovenia", "es": "Spansk", "es-ar": "Spansk \u2013 Argentina", "es-bo": "Spansk \u2013 Bolivia", "es-cl": "Spansk \u2013 Chile", "es-co": "Spansk \u2013 Colombia", "es-cr": "Spansk \u2013 Costa Rica", "es-cu": "Spansk \u2013 Cuba", "es-do": "Spansk \u2013 Den dominikanske repulikk", "es-ec": "Spansk \u2013 Ecuador", "es-sv": "Spansk \u2013 El Salvador", "es-gt": "Spansk \u2013 Guatemala", "es-hn": "Spansk \u2013 Honduras", "es-mx": "Spansk \u2013 Mexico", "es-ni": "Spansk \u2013 Nicaragua", "es-pa": "Spansk \u2013 Panama", "es-py": "Spansk \u2013 Paraguay", "es-pe": "Spansk \u2013 Peru", "es-pr": "Spansk \u2013 Puerto Rico", "es-es": "Spansk \u2013 Spania", "es-us": "Spansk \u2013 USA", "es-uy": "Spansk \u2013 Uruguay", "es-ve": "Spansk \u2013 Venezuela", "sw": "Swahili", "sv": "Svensk", "sv-fi": "Svensk \u2013 Finland", "sv-se": "Svensk \u2013 Sverige", "sy": "Gammelsyrisk", "ta": "Tamil", "tt": "Tatarisk", "te": "Telugu", "th": "Thai", "th-th": "Thai \u2013 Thailand", "tl": "Tagalog", "tr": "Tyrkisk", "tr-tr": "Tyrkisk \u2013 Tyrkia", "uk": "Ukrainsk", "uk-ua": "Ukrainsk \u2013 Ukraina", "ur": "Urdu", "uz": "Usbekisk", "vi": "Vietnamesisk", "vi-vn": "Vietnamesisk \u2013 Vietnam", "yi": "Jiddish", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "no-no": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tm", "hoursAndMinutes": "{{ hours }} tm {{ minutes }} min", "days": "{{ days }} dager", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}t", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}t {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, utvidelse {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "no": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:no', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "no-no": { "videoPlayer": { "htmlTitle": "HubSpot-video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot-video", "controls": { "audioPlayer": "Lydspiller", "videoPlayer": "Videospiller", "play": "Spill", "playVideo": "Spill video", "pause": "Pause", "replay": "Spill p\xE5 nytt", "currentTime": "N\xE5v\xE6rende tid", "duration": "Varighet", "remainingTime": "Gjenv\xE6rende tid", "fullscreen": "Fullskjerm", "exitFullscreen": "Avslutt fullskjerm", "mute": "Demp", "unmute": "Opphev demping", "volumeLevel": "Volumniv\xE5", "captions": "Tekst", "captionsOff": "Av", "seekBar": "Justere posisjon", "chapter": "Kapittel", "elapsedTime": "Brukt tid: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Avspillingsalternativer", "playbackRate": "Avspillingshastighet", "quality": "Kvalitet:", "normal": "Normal", "auto": "(Automatisk)" }, "formModal": { "defaultThankYouMessage": "Takk for svaret ditt!", "inlineMessageButton": "Se video" }, "ctaModal": { "imgAlt": "Video-CTA" }, "errors": { "generic": { "heading": "Kunne ikke laste video" }, "UNAUTHORIZED": { "heading": "Video ikke aktivert" }, "VIDEO_NOT_FOUND": { "heading": "Video ikke funnet" }, "INVALID_URL": { "heading": "Video ikke funnet" }, "UNSUPPORTED_EMBED": { "heading": "Video ikke tilgjengelig", "extra": "Denne videoen kan ikke ses eksternt." }, "refreshLink": "Pr\xF8v igjen" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "no": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:no', {version: 'static-1.29208'}); }
})();


